import { Component, ElementRef, Inject, ViewChild } from '@angular/core'
import { MAT_DIALOG_DATA } from '@angular/material/dialog'
import { UploadModalConfig, UploadType } from '@app/shared/components/upload-modal/models/upload-modal-config'
import { UploadModalService } from './services/upload-modal.service'

@Component({
  selector: 'upload-modal',
  templateUrl: './upload-modal.component.html',
  styleUrls: ['./upload-modal.component.scss'],
  providers: [UploadModalService],
})
export class UploadModalComponent {
  @ViewChild('uploader') uploader: ElementRef

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: UploadModalConfig,
    protected uploadModalService: UploadModalService
  ) {
    uploadModalService.setModalConfig(data)
  }

  protected readonly UploadType = UploadType
}
